import {
  transErrorMessage1,
  transErrorMessage2,
  transErrorMessage3,
  transErrorMessage4,
  transErrorMessage5,
  transErrorMessage6,
  transErrorMessage7,
  transErrorMessage8,
  transErrorMessage9,
  transErrorMessage10,
} from '../../../../../constants';

/**
 * Phase 1.2: Extracted validation logic from TransportDialog.js (lines 454-523)
 * Validates transport form data before submission
 *
 * @param {Object} formData - The transport form data to validate
 * @returns {Object} { isValid: boolean, errorMessage: string | null }
 */
export const validateTransportForm = (formData) => {
  const {
    transportCompletedByOrganization,
    outcome,
    actualDepartureDate,
    personPerformingPickInitialDeparture,
    initialDepartureDate,
    StaffTimeQty,
    mileageQty,
  } = formData;

  // Use early returns instead of nested if-else for better readability

  // Rule 1: At least one of these fields must be filled
  if (
    transportCompletedByOrganization === '' &&
    outcome === '' &&
    actualDepartureDate === null
  ) {
    return { isValid: false, errorMessage: transErrorMessage1 };
  }

  // Rule 2: If outcome is 1 or 9, transportCompletedByOrganization is required
  if (transportCompletedByOrganization === '' && outcome === 1) {
    return { isValid: false, errorMessage: transErrorMessage2 };
  }

  if (transportCompletedByOrganization === '' && outcome === 9) {
    return { isValid: false, errorMessage: transErrorMessage2 };
  }

  // Rule 3: If outcome is set (and not 1 or 9), transportCompletedByOrganization is required
  if (transportCompletedByOrganization === '' && outcome !== 1) {
    return { isValid: false, errorMessage: transErrorMessage3 };
  }

  if (transportCompletedByOrganization === '' && outcome !== 9) {
    return { isValid: false, errorMessage: transErrorMessage3 };
  }

  // Rule 4: If transportCompletedByOrganization is set, personPerformingPickInitialDeparture is required
  if (
    transportCompletedByOrganization !== '' &&
    personPerformingPickInitialDeparture === ''
  ) {
    return { isValid: false, errorMessage: transErrorMessage4 };
  }

  // Rule 5: If transportCompletedByOrganization is set, initialDepartureDate is required
  if (
    transportCompletedByOrganization !== '' &&
    initialDepartureDate === null
  ) {
    return { isValid: false, errorMessage: transErrorMessage5 };
  }

  // Rule 6: If outcome is set, actualDepartureDate is required
  if (outcome && actualDepartureDate === null) {
    return { isValid: false, errorMessage: transErrorMessage6 };
  }

  // Rule 7: actualDepartureDate must match initialDepartureDate
  if (
    actualDepartureDate !== null &&
    actualDepartureDate !== initialDepartureDate
  ) {
    return { isValid: false, errorMessage: transErrorMessage7 };
  }

  // Rule 8: If actualDepartureDate is set, outcome is required
  if (actualDepartureDate !== null && outcome === '') {
    return { isValid: false, errorMessage: transErrorMessage8 };
  }

  // Rule 9: If StaffTimeQty is set, mileageQty is required
  if (StaffTimeQty !== null && mileageQty === null) {
    return { isValid: false, errorMessage: transErrorMessage9 };
  }

  // Rule 10: If mileageQty is set, StaffTimeQty is required
  if (mileageQty !== null && StaffTimeQty === null) {
    return { isValid: false, errorMessage: transErrorMessage10 };
  }

  // All validation rules passed
  return { isValid: true, errorMessage: null };
};
